module.exports = __webpack_public_path__ + "static/media/smart_service_2_EN.d17bb3f5.png";